import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPerson = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M10.1333 9.05841C10.05 9.05008 9.94999 9.05008 9.85832 9.05841C7.87499 8.99175 6.29999 7.36675 6.29999 5.36675C6.29999 3.32508 7.94999 1.66675 9.99999 1.66675C12.0417 1.66675 13.7 3.32508 13.7 5.36675C13.6917 7.36675 12.1167 8.99175 10.1333 9.05841Z",
		stroke: "black",
		strokeOpacity: .6,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5.96666 12.1333C3.95 13.4833 3.95 15.6833 5.96666 17.0249C8.25833 18.5583 12.0167 18.5583 14.3083 17.0249C16.325 15.6749 16.325 13.4749 14.3083 12.1333C12.025 10.6083 8.26666 10.6083 5.96666 12.1333Z",
		stroke: "black",
		strokeOpacity: .6,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgPerson;
